module.exports = __webpack_public_path__ + "static/media/cart.fd9e2567.svg";